import Api from '@/services/Index';

const getStudentsInformation = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/esl/attendances/student-informations/${id}`);
}

export default {
    getStudentsInformation,

}
